import { MutationTree } from 'vuex'
import { ProfessionalsState } from '@/store/modules/professionals/professionalsTypes'

export const mutations: MutationTree<ProfessionalsState> = {
  FETCH_PROFESSIONALS(state, professionals) {
    const list = professionals
    state.professionals = list
  }
}
